module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"CartInfo":{"titleScreenReader":"Obsah košíku"}},"de":{"CartInfo":{"titleScreenReader":"Inhalt des Wagens"}},"sk":{"CartInfo":{"titleScreenReader":"Obsah košíka"}}}')
  delete Component.options._Ctor
}
